export const GUESS_COUNT = 6;
export const LETTER_COUNT = 5;
export const CORRECT_WORD = 'kūņot'
export const GUESS_LIST = [
  // 'teste',
  // 'meast'
]
